import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { GameTypeName, GameTypeUrl } from '../../../types/Game';
import { DEFAULT_PROMO_IMAGE, getBackground } from '../../../utils/assets';
import styles from '../shared.scss';

export interface BackgroundProps {
  winUpTo: string;
  gameType: GameTypeName;
  isUltra: boolean;
  url: GameTypeUrl;
  promoRef: string;
}

const Background: React.FC<BackgroundProps> = ({ winUpTo, gameType, isUltra, url, promoRef }) => {
  const locale = useSelector(select.locale.get);
  const asset = React.useMemo(
    () => getBackground(url, gameType, isUltra, locale, promoRef),
    [promoRef, url, gameType, locale, isUltra]
  );
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!promoRef) return;

    // Re-trigger image load to handle error on slow networks
    const handleImageError = (_: string | Event) => {
      if (imgRef?.current) imgRef.current.src = DEFAULT_PROMO_IMAGE[gameType];
    };

    const imgElement = imgRef.current;
    if (imgElement) {
      imgElement.src = asset;
      imgElement.onerror = handleImageError;
    }
  }, [asset, promoRef, gameType]);

  return (
    <picture className={styles.bgr}>
      <img
        src={asset}
        ref={imgRef}
        // @ts-expect-error not supported in current react version
        fetchpriority="high"
        loading="eager"
        alt={`Poker tile background for ${gameType} game where you can win up to ${winUpTo}`}
      />
    </picture>
  );
};

export default Background;
